import * as React from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { ExchangeOrderFragment } from '@websky/graphql';
import { useTheme } from '../../../../../../theme';
import { useToggleable } from '../../../../../../hooks';
import { BaseButton } from '../../../../../../BaseComponents';
import ModalConfirm from '../../../../../../ModalConfirm';

import { useRefuseExchange } from '../../model/useRefuseExchange';

interface Props {
	className?: string;
	onSuccess?: (exchangeOrder: ExchangeOrderFragment) => void;
}

const RefuseExchangeButton: React.FC<Props> = ({ className, onSuccess }) => {
	const { t } = useTranslation('Exchange');
	const { RefuseExchangeButton: theme } = useTheme('Features').Exchange;

	const { isOpen, open, close } = useToggleable(false);
	const { onRefuseExchange, isLoading } = useRefuseExchange();

	const onRefuseExchangeHandler = useCallback(() => {
		onRefuseExchange({ onSuccess });
		close();
	}, [onSuccess, onRefuseExchange, close]);

	return (
		<>
			<BaseButton variant="secondary" className={cn(theme.root, className)} isLoading={isLoading} onClick={open}>
				{t('RefuseExchangeButton.Label')}
			</BaseButton>

			<ModalConfirm
				isOpen={isOpen}
				title={t('RefuseExchangeButton.ModalLabel')}
				onClose={close}
				onCancel={close}
				onConfirm={onRefuseExchangeHandler}
			>
				{t('RefuseExchangeButton.ModalText')}
			</ModalConfirm>
		</>
	);
};

export default RefuseExchangeButton;
